module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "input"
  }, [(_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "left",
    attrs: {
      "placeholder": _vm.hint,
      "type": "password"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : (_vm.type == 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "left",
    attrs: {
      "placeholder": _vm.hint,
      "type": "number"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "left",
    attrs: {
      "placeholder": _vm.hint,
      "type": "text"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), (!!_vm.rightText) ? _c('div', {
    class: _vm.rightStyle == 'normal' ? 'right-normal' : 'right-color',
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.rightText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-divide"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8998aa1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/input.vue
// module id = 876
// module chunks = 34